import type { ComponentRef, ViewContainerRef } from '@angular/core';
import type { AbstractControl } from '@angular/forms';

import type { Observable, Subject } from 'rxjs';

import type { ViewFilterDef, ViewFilterInput, ViewFilterInputDef } from '@core/views-types';

import type { InputTypeComponent } from '../advanced-filters/filter/types';

export interface FilterTypeComponentProvider {
  type: string;
  service: InputServiceClass;
}
export enum FilterEvents {
  InputBlur,
  ChipRemove,
  Clear,
}

export type InputServiceClass = new () => InputService;
export interface InputComponentContext {
  dataSourceId: string;
  filterDef: ViewFilterDef;
  inputDef: ViewFilterInputDef;
  inputs: ViewFilterInputDef[];
  origin: 'all' | 'quick';
  uuid: string;
  filterEvents: Subject<{ inputId: string; event: FilterEvents }>;
}
export interface InputService {
  savedToFormValue: (inputValue: ViewFilterInput<unknown>) => unknown;
  getComponentState: (inputValue: ViewFilterInput<unknown>) => unknown;
  getInputControl: (input: ViewFilterInputDef) => AbstractControl<unknown>;
  createInputComponent: (
    vcRef: ViewContainerRef,
    destroy$: Observable<void>,
    context: InputComponentContext,
  ) => ComponentRef<InputTypeComponent<any, unknown, any>>;
  updateInputs: (
    cmpRef: ComponentRef<InputTypeComponent<any, unknown, any>>,
    inputs: Partial<
      Pick<InputTypeComponent<any, unknown, any>, 'inputControl' | 'state' | 'showBackButton$'>
    >,
  ) => void;
  getInputLabel: (
    context: Pick<InputComponentContext, 'dataSourceId' | 'filterDef' | 'inputDef' | 'uuid'>,
    control: AbstractControl<unknown>,
    inputState$: Observable<unknown>,
  ) => Observable<string>;
}
